import { render, staticRenderFns } from "./BackCard.vue?vue&type=template&id=d9ee2f7a&scoped=true&"
import script from "./BackCard.vue?vue&type=script&lang=js&"
export * from "./BackCard.vue?vue&type=script&lang=js&"
import style0 from "./BackCard.vue?vue&type=style&index=0&id=d9ee2f7a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ee2f7a",
  null
  
)

export default component.exports